import type { Translations } from '../types';

export const ko: Translations = {
  common: {
    appName: 'Recovery Drill',
    loading: '로딩 중…',
    back: '뒤로',
    done: '완료',
    continue: '계속하기',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    unlock: '잠금 해제',
    lock: '잠금',
    restore: '복원',
    settings: '설정',
    readiness: '준비도',
    gotIt: '확인',
    days: '일',
    months: '개월',
    tomorrow: '내일',
    inDays: (days: number) => `${days}일 후`,
    dueYesterday: '어제 기한 만료',
    dueToday: '오늘 예정',
    dueTomorrow: '내일 예정',
    dueInDays: (days: number) => `${days}일 후 예정`,
    dueInMonths: (months: number) => `${months}개월 후 예정`,
    daysOverdue: (days: number) => `${days}일 지남`,
    never: '없음',
  },
  nav: {
    readiness: '준비도',
    settings: '설정',
    home: '홈',
    howItWorks: '작동 원리',
    whatWeCanSee: '데이터 공개 원칙',
    openApp: '앱 열기',
    startDrill: '훈련 시작',
  },
  landing: {
    badge: 'Recovery Drill',
    heroTitle: '암호화폐의 대부분은 해킹이 아닌 망각으로 분실됩니다.',
    heroP1:
      '기억나지 않는 서랍 속, 이사 간 옛집, 한 번 적어두고 다시는 보지 않은 쪽지 때문에 사라집니다. 시드 구문 자체는 안전했을지 몰라도, 그것이 어디에 있는지에 대한 기억은 그렇지 못했습니다.',
    heroP2:
      'Recovery Drill은 아무도 연습하지 않는 한 가지를 훈련합니다. 바로 백업을 실제로 찾아내는 것입니다. 그리고 이 모든 과정은 여러분의 백업을 서버에 전혀 저장하지 않고 진행됩니다.',
    startCta: '훈련 시작하기',
    continueGoogle: 'Google 계정으로 계속하기',
    signingIn: '로그인 중…',
    emailDisclaimer:
      '알림 전송 목적으로만 사용됩니다. 귀하의 이메일은 볼트(힌트 저장소)에 절대 닿지 않습니다.',
    claimsHeading: '서버가 볼 수 있는 것과 볼 수 없는 것',
    claimsSub:
      '이는 단순한 정책 약속이 아닌 기술적/구조적 보장입니다. 힌트를 다루는 코드는 네트워크 통신 모듈 임포트가 린트 룰에 의해 원천 차단되며, 이 규칙이 수정되면 빌드 자체가 실패합니다.',
    claims: [
      {
        title: '복구 구문(시드 문구)은 절대 수집하지 않습니다',
        body: '시드 구문을 입력하는 필드 자체가 없습니다. 앱은 시드 구문 형태의 입력(영어 및 한국어)을 실시간으로 감지하여 저장되기 전 즉시 파기합니다.',
      },
      {
        title: '힌트는 기기 내부에서 암호화됩니다',
        body: '앱이 생성한 볼트 키로 잠기며, 이 키는 개발자도 재설정할 수 없습니다. 재설정하지 않는 것이 아니라, 서버에 재설정을 위한 데이터 자체가 존재하지 않기 때문입니다.',
      },
      {
        title: '서버에는 오직 일정과 점수만 보관됩니다',
        body: '다음 훈련이 언제인지, 힌트를 몇 단계까지 보았는지, 백업이 그 자리에 여전히 있었는지만 저장됩니다. 백업의 위치를 유추할 수 있는 정보는 전혀 없습니다.',
      },
    ],
    stepsHeading: '훈련 진행 방식',
    steps: [
      {
        n: '01',
        title: '비밀이 아닌 힌트를 작성합니다',
        body: '가장 얕은 1단계부터 깊은 5단계까지 작성합니다. 1단계는 타인에게 아무 의미가 없어야 하며, 5단계는 기억이 완전히 희미해진 날에도 백업을 찾을 수 있게 도와줍니다.',
      },
      {
        n: '02',
        title: '정해진 주기에 질문을 받습니다',
        body: '푸시 알림, 링크가 없는 안전한 이메일, 혹은 캘린더에 단순히 "준비도 체크"로 표시되는 일정 중 원하는 방식으로 알림을 받습니다.',
      },
      {
        n: '03',
        title: '실제로 가서 백업을 확인합니다',
        body: '종이나 메탈 플레이트에 적힌 복구 코드를 읽어 입력하면, 백업이 물리적으로 존재함을 증명하는 훈련이 완료됩니다.',
      },
      {
        n: '04',
        title: '훈련 간격이 기억력에 맞춰 조절됩니다',
        body: '힌트 없이 성공하면 다음 주기가 최대 6개월까지 25%씩 늘어납니다. 힌트가 필요했거나 실패하면 주기는 다시 짧아집니다.',
      },
    ],
    paperHeading: '종이 한 장에 적어두는 두 가지',
    paperP1:
      '6개 단어로 된 볼트 키와 10자리 복구 코드를 백업 자체와 함께 보관합니다. 암호화된 백업 내보내기 파일(이 두 정보 없이는 복호화 불가)과 함께 완벽한 복구 체계가 완성됩니다.',
    paperP2:
      '볼트 키는 지갑 복구 구문(시드 구문)이 아닙니다. 암호화폐에 접근하거나 개인키를 추출할 수 없으며, 오직 이 기기에 저장된 힌트를 해제하는 용도로만 쓰입니다.',
    paperP3:
      'BIP-39 지갑 단어가 모두 제외된 특수 단어 목록에서 추출되므로, 볼트 키와 지갑 구문은 단 하나의 단어도 겹치지 않습니다. 수년 후에도 종이 위에서 명확히 구분할 수 있습니다.',
    footerNote: '이 앱은 기기 내부에만 힌트를 암호화 저장합니다. 영지식(Zero-knowledge) 아키텍처.',
  },
  howItWorks: {
    title: '작동 원리',
    subtitle: '평생 쓸 일이 없기를 바라는 소중한 물리적 백업을 위한 간격 반복 훈련 시스템.',
    twoClocksHeading: '하나가 아닌 두 개의 시계',
    recallTitle: '기억 회상 (Recall)',
    recallBody:
      '백업이 어디에 있는지 여전히 기억하고 있는지 측정합니다. 힌트 없이 성공할 때마다 주기가 25%씩 늘어나 최대 6개월까지 확장됩니다. 힌트가 필요하면 1개월로 단축되며, 깊은 힌트는 2주, 실패 시 1주일로 줄어듭니다.',
    physicalTitle: '물리적 검증 (Physical)',
    physicalBody:
      '백업이 여전히 그 자리에 있고 훼손되지 않았는지 확인합니다. 이 시계는 기억력과 무관하게 180일마다 고정됩니다. 부식되거나 잃어버린 백업을 완벽히 기억하고 있는 것은 아무 소용이 없기 때문입니다.',
    capNote:
      '물리적 검증 기한이 지나면, 기억 회상 점수와 무관하게 전체 준비도가 최대 60점으로 제한됩니다. 이는 "진짜 준비되어 있는가?"에 대한 정직한 척도입니다.',
    scoreHeading: '점수 산정 기준',
    scoreHalf: '전체 점수의 절반(50%)은 힌트를 얼마나 열어보았는지에 따라 결정됩니다.',
    scoringRows: [
      ['힌트 없이 찾음', '100점'],
      ['1단계 힌트 사용', '85점'],
      ['2단계 힌트 사용', '65점'],
      ['3단계 힌트 사용', '45점'],
      ['4단계 또는 5단계 힌트 사용', '20점'],
      ['찾지 못함', '0점'],
    ],
    scoreQuarter: '점수의 25%는 물리적 확인 증거의 신뢰도에 따라 결정됩니다.',
    verificationRows: [
      ['종이/플레이트에 적힌 복구 코드를 직접 확인', '100점'],
      ['실물 백업을 손에 쥐었으나 코드 미확인', '70점'],
      ['위치는 알지만 직접 가보지는 않음', '35점'],
      ['확인하지 않음', '0점'],
    ],
    scoreRemaining:
      '나머지 25%는 가장 최근에 훈련을 진행한 시점과 보고된 백업의 보관 상태에 따라 계산됩니다.',
    hintsCostHeading: '깊은 힌트가 잠겨 있는 이유',
    hintsCostBody:
      '4단계와 5단계 힌트는 정답에 매우 가깝기 때문에 볼트 키를 다시 입력해야만 열람할 수 있으며, 10초 후에 자동으로 다시 숨겨집니다. 쉽게 열어볼 수 있다면 기억하려는 노력을 건너뛰게 되어 훈련의 의미가 사라지기 때문입니다.',
    lostDeviceHeading: '기기를 분실한 경우',
    lostDeviceP1:
      '앱 설정 완료 시 암호화된 백업 파일 다운로드가 필수로 요구됩니다. 새 기기에서 이 파일과 볼트 키를 입력하면 모든 힌트가 즉시 복원됩니다. 둘 중 하나라도 없으면 무용지물이며, 서버에는 둘 다 저장되지 않습니다.',
    lostDeviceP2:
      '브라우저는 저장소를 정리할 수 있고 스마트폰은 분실될 수 있습니다. 내보내기 파일은 이 두 가지 상황이 반드시 일어날 것임을 전제로 설계되었습니다.',
  },
  privacy: {
    title: '데이터 공개 원칙',
    subtitle: '약관 요약이 아닌, 필드별로 어디에 무엇이 저장되는지 투명하게 공개합니다.',
    onDeviceHeading: '기기를 절대 벗어나지 않는 정보',
    onDeviceSub:
      '볼트 키로부터 파생된 키(Argon2id 64MiB, 3패스)로 AES-256-GCM 암호화됩니다. 내보내기 파일에도 오직 암호문 형태로만 존재합니다.',
    onDeviceItems: [
      '각 백업의 이름 (별칭)',
      '보관 매체 (종이, 스틸 플레이트 등)',
      '1단계부터 5단계까지의 모든 힌트 내용',
      '기억 확인용 질문, 보기 및 정답',
      '정확한 보관 위치 설명',
      '볼트 키 (힌트를 암호화하는 6개 단어)',
      '물리 확인용 복구 코드',
    ],
    onServerHeading: '서버로 전송되는 정보',
    onServerSub: '적절한 시간에 알림을 보내고 준비 상태를 측정하는 데 필요한 최소한의 데이터만 전송됩니다.',
    onServerItems: [
      '불투명한 백업 식별자 (난수 ID)',
      '훈련 주기 및 다음 예정일',
      '마지막 훈련 일시 및 마지막 실물 확인 일시',
      '훈련 성공 여부 및 사용한 힌트 깊이 (0~5 사이의 숫자)',
      '물리적 검증 방식 (코드 확인, 실물 확인, 기억 확인 등)',
      '5분 이내에 찾았는지 여부',
      '보고된 백업 보관 상태',
      '기억 회상 점수 및 전체 준비도 점수',
      '이메일 주소, 타임존 및 희망 알림 시간대',
      '복구 코드의 솔트 해시값 및 캘린더 피드 토큰 해시값',
    ],
    neverSendHeading: '우리가 절대 보내지 않는 것',
    neverSendP1:
      '지갑 시드 구문을 절대 요구하지 않으며, 앱 내에 시드 구문을 받는 필드도 없습니다. 단어를 입력하는 모든 필드는 시드 구문을 실시간 감지하여 저장 전에 파기합니다.',
    neverSendP2:
      '우리가 보내는 이메일에는 어떠한 링크도 포함되지 않습니다. 로그인 링크, 구독 취소 링크, 추적 픽셀이 전혀 없습니다. 링크가 포함되어 있거나 시드 구문, 볼트 키, 복구 코드를 묻는 메일을 받으셨다면 사칭 메일입니다.',
    neverSendP3:
      '푸시 알림은 "복구 훈련 예정"이라는 문구만 표시합니다. 캘린더 일정은 "준비도 체크"로만 표시됩니다. 타인이 화면을 보더라도 암호화폐 관련 정보임을 알 수 없습니다.',
    deleteAccountHeading: '계정을 삭제하는 경우',
    deleteAccountP1:
      '서버에 저장된 일정, 점수, 훈련 기록, 기기 토큰이 즉시 영구 삭제되며 기기의 볼트 데이터도 초기화됩니다. 기존에 다운로드한 백업 파일은 볼트 키로 암호화되어 있어 서버 존재 여부와 상관없이 계속 작동합니다.',
  },
  auth: {
    headline: '필요해지기 전에, 백업 찾는 연습을 시작하세요.',
    lead:
      '암호화폐의 대부분은 해킹이 아닌 망각으로 분실됩니다. 기억나지 않는 서랍 속, 이사 간 옛집, 한 번 적어두고 다시는 보지 않은 쪽지 때문입니다.',
    bullet1:
      '우리는 귀하의 시드 구문을 절대 보지 못합니다. 입력할 필드도, 서버로 전송할 방법도 없습니다.',
    bullet2:
      '힌트는 앱이 생성한 고유 키로 기기 내에서 암호화됩니다. 이는 지갑 구문이 아니며 자산에 접근할 수 없습니다.',
    bullet3:
      '서버에는 오직 훈련 일정과 점수만 저장되며, 타인에게 노출되어도 안전한 정보만 다룹니다.',
    signInButton: 'Google 계정으로 계속하기',
    signingIn: '로그인 중…',
    error: '로그인을 완료하지 못했습니다.',
    emailDisclaimer:
      '알림을 보낼 주소를 확인하기 위해서만 사용됩니다. 이메일 정보는 볼트에 절대 닿지 않습니다.',
  },
  dashboard: {
    title: '준비도',
    nothingTracked: '등록된 백업이 없습니다.',
    trackedCount: (count: number) => `${count}개의 백업 추적 중`,
    drillDueTitleSingle: '훈련 예정된 백업이 있습니다',
    drillDueTitleMultiple: (count: number) => `${count}개의 훈련이 예정되어 있습니다`,
    drillDueDesc: '약 2분 정도 소요됩니다. 나중에 완벽히 하는 것보다 지금 바로 확인하는 것이 중요합니다.',
    startDrillCta: '훈련 시작하기',
    locked: '잠김',
    unreadable: '이 기기에서 읽을 수 없음',
    emptyTitle: '아직 등록된 백업이 없습니다',
    emptyBody:
      '백업을 추가하면 정해진 주기에 맞춰 찾는 연습을 도와드립니다. 성공할수록 주기가 늘어나고, 실패하면 다시 짧아집니다.',
    emptyCta: '백업 추가하기',
  },
  readinessBands: {
    ready: '준비됨',
    due_soon: '기한 임박',
    at_risk: '주의 필요',
    action_required: '조치 필요',
    meanings: {
      ready: '최근 힌트 없이 스스로 찾아냈습니다. 안전한 상태입니다.',
      due_soon: '여전히 양호하지만, 다음 훈련을 제때 진행하는 것이 좋습니다.',
      at_risk: '지난 훈련에서 힌트가 필요했습니다. 지금 짧게 확인해보세요.',
      action_required: '단순 알림을 넘어 일정을 재조정하거나 실물을 점검해야 합니다.',
    },
  },
  persistence: {
    noBackupTitle: '백업 파일 미저장',
    noBackupBody:
      '힌트는 현재 이 기기에만 존재합니다. 브라우저가 저장소를 정리할 경우, 백업 파일이 있어야 복구할 수 있습니다.',
    noBackupCta: '지금 파일 다운로드',
    installTitle: '홈 화면에 앱 추가',
    installBody:
      '홈 화면에 설치된 앱은 브라우저의 주기적인 임시 저장소 자동 정리 대상에서 제외됩니다.',
    installCta: '설치하기',
    notPersistentTitle: '영구 저장소 미승인',
    notPersistentBody:
      '브라우저가 아직 영구 저장소 권한을 부여하지 않았습니다. 앱을 계속 사용하면 자동 승인되며, 백업 파일이 있으면 안전합니다.',
  },
  setup: {
    explainTitle: '먼저, 힌트를 보호할 볼트 키를 생성합니다',
    explainBody:
      '여기에 작성하는 백업 이름, 재질, 5단계 힌트, 정확한 위치 등 모든 정보는 기기에 저장되기 전에 암호화됩니다. 이 암호화에는 전용 키가 필요하며, 지금 6개 단어(77비트 엔트로피)로 구성된 볼트 키가 생성됩니다.',
    notWalletTitle: '이것은 지갑 복구 구문이 아닙니다.',
    notWalletBody:
      '어떠한 암호화폐에도 접근할 수 없고, 지갑을 복원하거나 개인키를 도출할 수 없습니다. 오직 이 기기에 암호화된 힌트를 해제하는 용도로만 사용됩니다.',
    notWalletSub:
      'BIP-39 지갑 단어가 모두 제외된 목록에서 추출되므로, 종이에 함께 적어두어도 지갑 시드 구문과 절대 혼동되지 않습니다.',
    factAppTitle: '직접 비밀번호를 정하지 않고 앱이 생성하는 이유',
    factAppBody:
      '직접 설정하는 암호는 로컬 암호화에서 가장 취약한 고리가 됩니다. 이 키는 앞으로 작성할 모든 힌트를 평생 보호해야 하므로, 앱이 강력한 무작위 키를 생성하고 서버에는 절대 남기지 않습니다.',
    factResetTitle: '개발자도 재설정해줄 수 없는 이유',
    factResetBody:
      '서버에 복호화 정보가 전혀 없기 때문입니다. 우리는 귀하의 힌트를 가지고 있지 않으므로 법원 명령이 있더라도 풀어드릴 수 없습니다.',
    factLossTitle: '볼트 키를 분실하면 어떻게 되나요?',
    factLossBody:
      '힌트는 영원히 복호화할 수 없게 되며, 스스로 백업 위치를 기억해내야 합니다. 실제 암호화폐 자산 자체에는 아무런 영향이 없습니다.',
    factKeepTitle: '어디에 보관해야 하나요?',
    factKeepBody:
      '종이에 적어 실물 백업과 함께 라벨을 붙여 보관하세요. 스마트폰 내 메모장이나 비밀번호 관리자에 저장하면 폰 분실 시 둘 다 잃게 됩니다.',
    generateKeyCta: '볼트 키 생성하기',
    showKeyTitle: '생성된 볼트 키',
    showKeyBody:
      '6개의 단어입니다. 종이에 직접 적으세요. 스마트폰 메모장에 적으면 폰을 잃어버렸을 때 함께 분실됩니다.',
    vaultKeyLabel: '볼트 키',
    showKeyInstruction:
      '종이 옆에 "볼트 키(VAULT KEY)"라고 명확히 적어두세요. 지갑 시드 백업과 함께 보관하더라도 수년 후에 헷갈리지 않게 해줍니다.',
    showKeyWarning: '이 화면은 다시 표시되지 않습니다. 서버는 이를 다시 생성할 수 있는 데이터를 저장하지 않습니다.',
    writtenDownCta: '종이에 모두 적었습니다',
    confirmTitle: '적어둔 단어를 입력하세요',
    confirmBody:
      '기억이 아니라 방금 적은 종이를 보면서 입력하세요. 실제로 종이에 제대로 적혔는지 확인할 수 있는 유일한 방법입니다.',
    mismatchWarning: '일치하지 않습니다. 종이에 적힌 단어를 다시 확인하세요.',
    creatingVault: '볼트 생성 중…',
    createVaultCta: '볼트 생성 완료',
    showAgainCta: '단어 다시 보여주기',
    exportTitle: '백업 파일 저장',
    exportP1:
      '이 파일과 볼트 키가 있으면 새 스마트폰에서도 모든 힌트를 복원할 수 있습니다. 파일 단독으로는 암호화되어 있어 타인이 읽을 수 없습니다.',
    exportP2:
      '브라우저 저장소가 초기화되거나 폰을 분실할 때를 대비하는 필수 단계이므로 건너뛸 수 없습니다.',
    downloadAgain: '다시 다운로드',
    downloadFile: '백업 파일 다운로드',
    continueCta: '계속하기',
    downloadFirstCta: '파일을 다운로드해야 계속할 수 있습니다',
  },
  newAnchor: {
    title: '새 백업 등록',
    lead:
      '입력하는 내용은 절대 폰 밖으로 나가지 않습니다. 5년 뒤 완전히 잊어버렸을 때를 상상하며 작성하세요.',
    nameLabel: '이 백업을 뭐라고 부르시나요?',
    namePlaceholder: '스틸 플레이트 1번',
    mediumLabel: '어떤 재질에 보관되어 있나요?',
    mediumPlaceholder: '각인된 메탈 플레이트, 방화 금고 속 종이 등',
    mediumHint: '내용물이 아닌 보관 형태를 적으세요.',
    ladderLegend: '5단계 힌트 사다리',
    ladderDesc:
      '단계가 깊어질수록 구체적인 힌트가 됩니다. 힌트 없이 찾는 것이 가장 높은 점수를 받으므로, 앞쪽 단계는 막연하게 작성하는 것이 좋습니다.',
    ladderPrompts: [
      ['1단계 — 거의 도움 안 됨', '타인이 봐도 아무것도 알 수 없어야 합니다. 예: "집 안 어디가"'],
      ['2단계 — 범위 좁히기', '방, 층, 또는 대략적인 공간 범주.'],
      ['3단계 — 구체적인 단서', '특정 가구, 벽면, 보관함 이름 등.'],
      ['4단계 — 거의 다 옴', '몇 번째 서랍, 선반의 어느 쪽 등.'],
      ['5단계 — 확실한 위치', '기억이 완전히 사라진 날 보고 바로 찾을 수 있는 설명.'],
    ],
    questionLegend: '순차 기억 확인 질문',
    questionDesc:
      '힌트를 보기 전에 먼저 대답하게 됩니다. 백업에 대한 기억이 아직 남아있는지 측정합니다.',
    questionLabel: '질문',
    questionPlaceholder: '어느 방에 보관되어 있나요?',
    answerLabel: '정답',
    answerPlaceholder: '서재',
    decoyALabel: '그럴듯한 오답 1',
    decoyAPlaceholder: '안방 드레스룸',
    decoyAHint: '보기 순서는 무작위로 섞입니다.',
    decoyBLabel: '그럴듯한 오답 2',
    decoyBPlaceholder: '거실 수납장',
    locationLabel: '정확한 최종 위치 설명',
    locationHint:
      '볼트 키를 다시 입력해야만 열람할 수 있으며, 10초 후에 자동으로 다시 숨겨집니다.',
    cadenceQuestion: '처음 시작할 훈련 주기를 선택하세요',
    cadenceExplainer: (max: number, min: number) =>
      `첫 훈련은 선택과 무관하게 1주일 뒤에 진행됩니다. 이후 힌트 없이 성공하면 주기가 최대 ${max}일까지 늘어나고, 실패하면 ${min}일로 줄어듭니다.`,
    addingButton: '등록 중…',
    addButton: '백업 등록하기',
    codeTitle: '이 코드를 종이에 함께 적으세요',
    codeDesc: '볼트 키를 적은 종이와 동일하게, 실물 백업과 함께 보관하세요.',
    codeP1:
      '훈련 시 이 코드를 읽어 입력하면 백업을 기억하는 것에 그치지 않고 실제로 손에 쥐었음을 증명하게 됩니다. 가장 높은 신뢰도 점수를 받게 됩니다.',
    codeP2: '서버에는 솔트 해시값만 저장되므로, 이 화면을 닫으면 누구도 다시 확인할 수 없습니다.',
    codeAck: '실물 백업과 함께 종이에 코드를 적었습니다.',
    codeDone: '완료',
  },
  anchorDetail: {
    notFound: '해당 백업을 찾을 수 없습니다',
    backButton: '준비도로 돌아가기',
    locked: '잠김',
    unreadable: '이 기기에서 읽을 수 없음',
    clockRecall: '기억 회상',
    clockPhysical: '물리 검증',
    everyNDays: (days: number) => `${days}일 주기`,
    neverVerified: '검증 기록 없음',
    lastSeenDays: (days: number) => `${days}일 전 확인`,
    capWarning:
      '물리적 실물 확인을 완료하기 전까지, 회상 점수가 아무리 높아도 준비도는 최대 60점으로 제한됩니다.',
    scheduleHeading: '일정 설정',
    rehearseFrequency: '훈련 주기 설정',
    rehearseDesc: (max: number, min: number) =>
      `기본 주기이며, 성공 시 최대 ${max}일까지 확장되고 실패 시 ${min}일로 단축됩니다.`,
    remindersPaused: '알림이 일시정지됨',
    pauseReminders: '알림 일시정지',
    pausedDesc: '예정된 훈련이 중단되며 점수도 변동되지 않습니다.',
    activeDesc: '데이터 삭제 없이 알림 일정만 멈춥니다.',
    resumeButton: '재개하기',
    pauseButton: '일시정지',
    codeHeading: '물리 복구 코드',
    issueNewCode: '새 복구 코드 발급',
    issueNewCodeDesc:
      '종이를 분실했거나 타인에게 노출되었거나 훼손된 경우 재발급합니다. 기존 코드는 즉시 무효화됩니다.',
    rotateButton: '재발급',
    dangerHeading: '위험 작업',
    deleteBackup: '이 백업 삭제',
    deleteBackupDesc:
      '일정, 점수, 훈련 기록 및 기기 내 힌트를 모두 삭제합니다. 실물 백업 자체는 영향받지 않습니다.',
    deleteButton: '삭제',
    rotateSheetTitleNew: '종이에 새 코드를 적으세요',
    rotateSheetTitleConfirm: '복구 코드를 새로 발급할까요?',
    rotateSheetCrossOut:
      '기존 코드는 지우세요. 이 화면은 다시 표시되지 않으며 솔트 해시만 저장됩니다.',
    rotateSheetWarning:
      '새 코드를 훈련에서 검증할 때까지 물리 미검증 상태가 되어 180일 시계가 즉시 만료 상태로 재설정됩니다.',
    rotateSheetWritten: '종이에 적었습니다',
    rotateSheetConfirmBody:
      '새 코드가 발급되는 즉시 기존 코드는 사용할 수 없게 되며, 새 코드로 훈련을 마칠 때까지 물리 확인 기한 만료로 표시됩니다.',
    rotateSheetIssuing: '발급 중…',
    rotateSheetIssueCta: '새 코드 발급',
    deleteSheetTitle: '이 백업을 삭제하시겠습니까?',
    deleteSheetBody:
      '힌트, 일정, 기록이 영구히 제거됩니다. 금고나 서랍에 보관된 실제 백업(플레이트, 종이)에는 영향이 없습니다.',
    deleteSheetConfirm: '삭제하기',
    deleteSheetKeep: '유지하기',
    nowEveryDays: (days: number) => `이제 ${days}일마다 훈련합니다.`,
    scheduleError: '일정을 변경하지 못했습니다.',
    pausedNotice: '알림이 일시정지되었습니다.',
    resumedNotice: '알림이 재개되었습니다.',
    statusError: '상태를 변경하지 못했습니다.',
    newCodeError: '새 코드를 발급하지 못했습니다.',
    deleteError: '백업을 삭제하지 못했습니다.',
  },
  drill: {
    notFoundTitle: '해당 훈련을 찾을 수 없습니다',
    notFoundBody: '이미 완료되었거나 다른 계정에 속한 훈련입니다.',
    unlockTitle: '훈련을 진행하려면 잠금을 해제하세요',
    unlockBody: '힌트는 기기에 암호화되어 있으며 서버에는 존재하지 않습니다.',
    tagPhysical: '물리 실물 점검',
    tagRecall: '기억 회상 훈련',
    questionDesc: '기억만으로 답변하세요. 힌트는 아직 제공되지 않으며, 기억이 온전한지 측정합니다.',
    searchTitle: '이제 실제로 가서 백업을 확인하세요',
    searchBody: '직접 걸어가서 확인하세요. 힌트 없이 찾아내는 것이 화면의 어떤 답보다 가치가 큽니다.',
    hintLabel: (level: number) => `${level}단계 힌트`,
    showHintButton: (level: number, deep: boolean) =>
      `${level}단계 힌트 보기${deep ? ' (볼트 키 필요)' : ''}`,
    needsVaultKey: '볼트 키 필요',
    foundItButton: '찾았습니다',
    couldNotFindButton: '찾지 못했습니다',
    notRightNowButton: '지금은 곤란함',
    verifyTitle: '실물을 직접 쥐고 계신가요?',
    verifyBody:
      '종이/플레이트에 적힌 복구 코드를 읽어 입력하는 것만이 백업의 실존을 증명합니다.',
    verifyCodeTitle: '손에 쥐고 있습니다 — 복구 코드를 입력하겠습니다',
    verifyCodeDetail: '가장 높은 신뢰도 증명.',
    verifySelfTitle: '손에 쥐고 있으나 코드는 확인하지 않음',
    verifySelfDetail: '물리적 점검으로 인정됩니다.',
    verifyMemoryTitle: '위치는 알지만 직접 가보지는 않음',
    verifyMemoryDetail: '180일 물리 검증 시계가 갱신되지 않습니다.',
    timeQuestion: '찾는 데 얼마나 걸렸나요?',
    timeUnder5: '5분 미만',
    timeOver5: '5분 이상',
    conditionTitle: '백업의 보관 상태는 어떤가요?',
    conditionBody: '종이는 바래고 잉크는 번지며 금속은 부식될 수 있습니다. 읽을 수 없는 백업은 없는 백업입니다.',
    conditionIntactTitle: '완벽함',
    conditionIntactDetail: '손상 없이 선명하게 읽을 수 있음.',
    conditionMinorWearTitle: '경미한 마모',
    conditionMinorWearDetail: '읽을 수 있으나 세월의 흔적이 있음.',
    conditionDegradedTitle: '판독 어려움',
    conditionDegradedDetail: '일부 글자가 흐릿해지고 있음.',
    conditionCompromisedTitle: '심각한 훼손 또는 분실',
    conditionCompromisedDetail: '즉시 새 백업을 제작해야 함.',
    doneTitle: '기록 완료',
    doneReadiness: (score: number, days: number) =>
      `현재 준비도는 ${score}점입니다. 다음 훈련은 ${days}일 후입니다.`,
    doneDowngraded:
      '복구 코드가 일치하지 않아 "실물 확인(코드 미확인)"으로 처리되었습니다. 올바르게 읽으셨다면 재발급 이전의 옛 코드일 수 있습니다.',
    snoozeDecisionTitle: '일정 점검이 필요합니다',
    snoozeDecisionBody:
      '이 훈련을 미룬 것이 벌써 세 번째입니다. 계속 알림만 받기보다는, 일정을 실제로 지킬 수 있는 주기로 변경하세요.',
    snoozeDecisionChange: '일정 변경하기',
    snoozeDecisionNotNow: '나중에 하기',
    snoozeWhenTitle: '언제로 미룰까요?',
    snoozeWhenBody:
      '미루는 것은 감점되지 않습니다. 다만 3회 이상 미루면 알림을 멈추고 조치 필요 상태로 전환됩니다.',
    snoozeCountText: (count: number) => `미룬 횟수: 3회 중 ${count}회`,
    gateReason: (level: number) =>
      `${level}단계 힌트는 정답에 매우 가까우므로 볼트 키를 다시 입력해야 합니다. 10초 후에 자동으로 다시 숨겨집니다.`,
    errorSubmit: '기록을 저장하지 못했습니다. 다시 시도하세요.',
    errorSnooze: '일정을 연기하지 못했습니다.',
  },
  unlock: {
    title: '잠금 해제',
    subtitle: '힌트는 이 기기 내부에서 암호화되어 보관됩니다.',
    noVaultTitle: '이 기기에 볼트가 없습니다',
    noVaultBody: '새 볼트를 설정하거나, 백업 파일과 볼트 키로 복원하세요.',
    setupCta: '볼트 생성하기',
    restoreCta: '파일에서 복원하기',
    biometricButton: '생체 인증 사용',
    biometricError: '생체 인증에 실패했습니다. 볼트 키를 사용하세요.',
    keyPlaceholder: '종이에 적힌 6개 단어',
    wrongKeyError: '볼트 키가 일치하지 않습니다.',
    unlocking: '잠금 해제 중…',
    unlockButton: '잠금 해제',
    restoreAlternative: '내보내기 파일에서 복원하기',
  },
  restore: {
    title: '볼트 복원',
    subtitle: '백업 내보내기 파일과 볼트 키만 있으면 복원할 수 있습니다.',
    chooseDifferent: '다른 파일 선택',
    chooseFile: '내보내기 파일 선택',
    previewSummary: (count: number, date: string) =>
      `${count}개의 백업 포함 (내보낸 날짜: ${date})`,
    keyPlaceholder: '종이에 적힌 6개 단어',
    restoring: '복원 중…',
    restoreButton: '복원하기',
    readError: '파일을 읽을 수 없습니다.',
    restoreError: '해당 파일에서 복원하지 못했습니다.',
  },
  settings: {
    title: '설정',
    languageHeading: '언어 설정',
    languageRowTitle: '표시 언어',
    languageRowDetail: 'English 또는 한국어를 선택하세요.',
    durabilityHeading: '데이터 내구성',
    backupFileTitle: '백업 내보내기 파일',
    backupFileSaved: (date: string) => `마지막 저장: ${date}`,
    backupFileNever: '저장된 적 없음. 폰 분실 시 복구할 수 있는 유일한 파일입니다.',
    saveAgain: '다시 저장',
    saveNow: '지금 저장',
    restoreTitle: '다른 기기에서 복원',
    restoreDetail: '백업 파일과 볼트 키로 새 기기에서 복원합니다.',
    restoreButton: '복원',
    deviceHeading: '현재 기기',
    biometricTitle: '생체 인증 잠금 해제',
    biometricEnabled: '활성화됨. 1~3단계 힌트를 바로 엽니다. 깊은 힌트는 볼트 키가 필요합니다.',
    biometricAvailable: '볼트 키 입력 없이 1~3단계 힌트를 엽니다.',
    biometricUnavailable: '이 브라우저에서는 지원되지 않습니다.',
    turnOff: '끄기',
    enable: '사용 설정',
    lockTitle: '지금 잠그기',
    lockExpires: (time: string) => `세션 캐시 만료 예정 시간: ${time}`,
    lockLocked: '볼트가 잠겨 있습니다.',
    lockButton: '잠금',
    remindersHeading: '알림 설정',
    pushTitle: '푸시 알림',
    pushGranted: '켜짐. 알림에는 "복구 훈련 예정" 문구만 표시됩니다.',
    pushDenied: '브라우저 설정에서 차단되었습니다. 이메일로 대체 전송됩니다.',
    pushUnsupported: '이 브라우저에서 지원되지 않습니다. 이메일로 전송됩니다.',
    pushDefault: '백업 이름이나 점수가 노출되지 않는 안전한 잠금 화면 알림입니다.',
    pushOn: '켜짐',
    pushTurnOn: '켜기',
    calendarTitle: '캘린더 구독',
    calendarDetail: '모든 일정은 "준비도 체크"로 표시되며 백업 관련 정보가 노출되지 않습니다.',
    calendarRotateAgain: 'URL 재발급',
    calendarGetLink: '구독 링크 받기',
    calendarOnceNote: '한 번만 표시됩니다. 재발급 시 기존 링크는 즉시 무효화됩니다.',
    accountHeading: '계정',
    signedInAs: '로그인 계정',
    signOut: '로그아웃',
    deleteEverything: '모든 데이터 삭제',
    deleteEverythingDetail: '서버의 일정, 점수 및 이 기기의 볼트를 영구 삭제합니다.',
    deleteButton: '삭제',
    deleteSheetTitle: '모든 데이터를 삭제하시겠습니까?',
    deleteSheetBody:
      '서버의 일정과 점수가 삭제되고 이 기기의 볼트가 초기화됩니다. 기존에 다운로드한 백업 파일은 볼트 키로 암호화되어 있어 계속 사용할 수 있습니다.',
    deletePlaceholder: 'DELETE 입력',
    deleteConfirmKeyword: 'DELETE',
    deletingState: '삭제 중…',
    deleteAction: '모두 삭제하기',
    notices: {
      backupSaved: '백업 파일이 저장되었습니다.',
      biometricEnabled: '1~3단계 힌트에 대한 생체 인증이 설정되었습니다.',
      biometricFailed: '이 기기에서 생체 인증 키를 생성하지 못했습니다.',
      pushEnabled: '푸시 알림이 활성화되었습니다.',
      pushFailed: '푸시 알림을 설정할 수 없습니다.',
    },
  },
  guards: {
    vaultKeyBlockedTitle: '지갑 시드 구문이 감지되었습니다',
    vaultKeyBlockedP1:
      '입력하신 내용은 실제 암호화폐를 제어하는 지갑 복구 구문(시드 문구)입니다. 이 앱은 시드 구문을 절대 저장하지 않으며 입력 필드가 즉시 지워졌습니다. 아무것도 저장되거나 전송되지 않았습니다.',
    vaultKeyBlockedP2:
      '이 입력창은 지갑 구문이 아닌 "볼트 키(앱 설정 시 생성된 6개 단어)"를 입력하는 곳입니다. 볼트 키는 지갑에 접근할 수 없으며 오직 기기 내 힌트를 여는 용도입니다.',
    vaultKeyBlockedP3:
      '종이에 둘 다 적어두셨다면, 지갑 단어 목록에 포함되지 않은 6단어가 바로 볼트 키입니다.',
    vaultKeyUnknownWord: (word: string) => `“${word}” 단어는 이 앱에서 사용하는 단어가 아닙니다.`,
    vaultKeyDidYouMean: (suggestions: string) => ` 혹시 다음 단어인가요: ${suggestions}?`,
    vaultKeyRemainingWords: (count: number) => `${count}개 단어가 더 필요합니다.`,
    guardedRunWarning: (count: number) =>
      `${count}개의 연속된 단어가 지갑 시드 단어 목록과 일치합니다. 힌트는 백업 위치를 가리켜야 하며 시드 구문 자체를 포함해서는 안 됩니다.`,
    guardedBlockTitles: {
      validChecksum: '지갑 복구 구문으로 보입니다',
      consecutiveRun: '지갑 복구 구문으로 보입니다',
      pasteVolume: '붙여넣은 내용에 복구 구문이 포함되어 있습니다',
    },
    guardedBlockBodies: {
      validChecksum:
        '입력하신 내용은 유효한 BIP-39 시드 구문입니다. 이 앱은 시드 구문을 보관하지 않으므로 입력 필드가 즉시 지워졌습니다. 아무것도 저장되거나 전송되지 않았습니다.',
      consecutiveRun:
        '6개 이상의 연속된 단어가 시드 구문 단어 목록과 일치합니다. 필드가 지워졌으며 저장되지 않았습니다. 백업 내용이 아닌 백업이 있는 위치에 대한 힌트를 작성하세요.',
      pasteVolume:
        '붙여넣은 텍스트에 여러 개의 시드 구문 단어가 포함되어 있습니다. 필드가 지워졌으며 저장되지 않았습니다. 힌트에 비밀 구문이 직접 포함되어서는 안 됩니다.',
    },
  },
};
